export default "__VITE_ASSET__62f5dbb2__"